import { MapPin } from "lucide-react";
import { FooterAnchorCol } from "@/components/Landing/primitives";

const FOOTER_PLATFORM = Object.freeze([
    { label: "Modules", id: "platform" },
    { label: "Why Edara", id: "why" },
    { label: "How it works", id: "how" },
]);

const FOOTER_SOLUTIONS = Object.freeze([
    { label: "Solution overview", id: "solutions" },
    { label: "The problem", id: "problem" },
    { label: "Customer proof", id: "customers" },
]);

const FOOTER_TRUST = Object.freeze([
    { label: "Security", id: "security" },
    { label: "Pricing", id: "pricing" },
    { label: "FAQ", id: "resources" },
]);

export default function Footer({ onBook, scrollTo }) {
    return (
        <footer className="bg-[#0A0A0A] text-zinc-400 border-t border-white/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-6">
                        <div className="flex items-center gap-3">
                            <img
                                src="/edara-logo.png"
                                alt=""
                                className="w-12 h-12 object-contain"
                            />
                            <span className="font-display text-2xl tracking-wider text-white">
                                EDARA{" "}
                                <span className="text-[#1FA8FF]">SOFTWARE</span>
                            </span>
                        </div>
                        <p className="mt-4 text-sm text-zinc-400 max-w-sm leading-relaxed">
                            Edara Software Pty Ltd. Tier 1 compliance, AI
                            automated.
                        </p>
                        <div className="mt-5 text-sm text-zinc-400">
                            <div className="flex items-start gap-2">
                                <MapPin className="w-4 h-4 text-[#1FA8FF] mt-0.5 shrink-0" />
                                <div>
                                    Edara Software Pty Ltd
                                    <br />
                                    Level 32, 200 George Street
                                    <br />
                                    Sydney NSW 2000, Australia
                                </div>
                            </div>
                        </div>
                        <div className="mt-5 text-sm text-zinc-400 flex flex-col gap-1.5">
                            <a
                                href="mailto:demo@edarasoftware.com.au"
                                className="hover:text-white inline-flex items-center gap-2"
                            >
                                demo@edarasoftware.com.au
                            </a>
                            <a
                                href="tel:+611300033272"
                                className="hover:text-white inline-flex items-center gap-2"
                            >
                                1300 033 272
                            </a>
                        </div>
                    </div>

                    <FooterAnchorCol
                        title="Platform"
                        items={FOOTER_PLATFORM}
                        scrollTo={scrollTo}
                    />
                    <FooterAnchorCol
                        title="Solutions"
                        items={FOOTER_SOLUTIONS}
                        scrollTo={scrollTo}
                    />
                    <FooterAnchorCol
                        title="Trust"
                        items={FOOTER_TRUST}
                        scrollTo={scrollTo}
                    />
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-zinc-500">
                    <p>© 2026 Edara Software Pty Ltd</p>
                    <div className="flex items-center gap-5">
                        <button
                            onClick={() => scrollTo("security")}
                            className="hover:text-white"
                        >
                            Security
                        </button>
                        <button
                            onClick={onBook}
                            className="hover:text-white"
                        >
                            Contact
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
}
